import { useMemo } from 'react';

import _ from 'lodash';

import type { LatestImage } from '../../@types/latestImages';
import { useUniversalToFDI } from '../../utils/internationalization/useUniversalToFDI';

export const isPediatricToothOdontogram = (toothId: number | string) => {
  if (/^[a-tA-T]+$/.test(toothId.toString()) && toothId !== 'missing')
    return true;
};
export const isPermanentToothOdontogram = (toothId: number | string) => {
  if (/^[1-9][0-9]?$/.test(toothId.toString()) && toothId !== 'missing')
    return true;
};

export const useFormatSelectedDistinctTeeth = (
  filteredImages: LatestImage[],
) => {
  const { displayToothNumber } = useUniversalToFDI();

  return useMemo(() => {
    const filteredTeethInImages = filteredImages?.map((image) => {
      const toothFindings = image.models?.tooth_identification?.findings;
      const distinctTeeth = _.uniqBy(toothFindings, 'toothNumber');
      const distinctTeethNumbers = distinctTeeth.map(
        (tooth) => tooth.toothNumber,
      );
      return distinctTeethNumbers;
    });
    const teethInImagesFlat = _.flatten(filteredTeethInImages);
    const distinctTeethInImages = _.uniq(teethInImagesFlat).filter(
      (tooth) => tooth !== 'missing',
    );
    const localizedTeeth = distinctTeethInImages.map(displayToothNumber);

    return localizedTeeth.join(', ');
  }, [displayToothNumber, filteredImages]);
};
